import { Injectable } from '@angular/core';
import { ParticipantOffersUrlBuilderService } from './participant-offers-url-builder.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppUrls } from '../app-urls';
import { String } from "typescript-string-operations";

@Injectable({
  providedIn: 'root'
})
export class MarkEventAsReadService {
  constructor(private _http: HttpClient, private _urlBuilder: ParticipantOffersUrlBuilderService) {}

  public markMessageAsRead(eventId: number): Observable<null> {
    const relativeUrl = String.Format(AppUrls.events.eventMarkAsRead, eventId);
    const absoluteUrl = this._urlBuilder.getTenderPlatformAbsoluteUrl(relativeUrl);

    return this._http.post<null>(absoluteUrl, {});
  }
}
